import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { RiOpenSourceFill } from 'react-icons/ri'
import { MdSpaceDashboard, MdPieChart } from 'react-icons/md'
import { IoSettingsSharp, IoLogOut } from 'react-icons/io5'
import { SiRelianceindustrieslimited } from 'react-icons/si'
import {fcpl_white_logo} from '../../helpers/Constants'

import './KrishnaDashboard.css'



function KrishnaDashboard() {

    const navigate = useNavigate()
    const location = useLocation()

    const { pathname } = location


    function navigatetopage(v) {
        navigate(v)
    }


    return (
        <div style={{ background: '#0072b1', height: '100vh', position: 'fixed', left: '0px', maxHeight: '100vh', top: '0px', alignItems: 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', justifyItems: 'center', width: '100%' }}>
                <div style={{ display: 'flex', width: '100%', flexDirection: 'column', margin: 'auto' }}>

                    <div style={{ borderBottom: '0px solid #fafafa',borderBottom:'1px solid white',display:'flex',alignItems:'center' }}>
                        <img className="inactive" src={fcpl_white_logo} style={{ width: '35px', height: '25px',marginTop:'20px',marginBottom:'10px',marginLeft:'0px',opacity:1 }} />
                    </div>

                    <div className={pathname !== '/krishna_dashboard' ? 'menu_option_kp_non_active' : 'menu_option_kp_active'} onClick={() => navigatetopage('/krishna_dashboard')}>
                        <MdSpaceDashboard size={18} className={pathname !== '/krishna_dashboard' ? 'icon_kp' : 'icon_kp_active'} />
                    </div>

                    <div className={pathname !== '/crm_report' ? 'menu_option_kp_non_active' : 'menu_option_kp_active'} onClick={() => navigatetopage('/crm_report')}>
                        <MdPieChart size={18} className={pathname !== '/crm_report' ? 'icon_kp' : 'icon_kp_active'} />
                    </div>


                    <div className={pathname !== '/add_industry' ? 'menu_option_kp_non_active' : 'menu_option_kp_active'} onClick={() => navigatetopage('/add_industry')}>
                        <SiRelianceindustrieslimited size={15} className={pathname !== '/add_industry' ? 'icon_kp' : 'icon_kp_active'} style={{ marginLeft: '2px' }} />
                    </div>

                    <div className={pathname !== '/contact_source' ? 'menu_option_kp_non_active' : 'menu_option_kp_active'} onClick={() => navigatetopage('/contact_source')}>
                        <RiOpenSourceFill size={18} className={pathname !== '/contact_source' ? 'icon_kp' : 'icon_kp_active'} />
                    </div>



                </div>


                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>

                    <div className={pathname !== '/settings' ? 'menu_option_kp_non_active' : 'menu_option_kp_active'} onClick={() => navigatetopage('/settings')}>
                        <IoSettingsSharp size={18} className={pathname !== '/settings' ? 'icon_kp' : 'icon_kp_active'} />
                    </div>

                    <div className={pathname !== '/log_out' ? 'menu_option_kp_non_active' : 'menu_option_kp_active'} onClick={() => navigatetopage('/bd_dashboard')}>
                        <IoLogOut size={18} className={pathname !== '/log_out' ? 'icon_kp' : 'icon_kp_active'} />
                    </div>
                </div>
            </div>
        </div>
    )
}


export default KrishnaDashboard